import { FlightDetailsInfoList } from "@flights/search-ui";
import React from "react";
import useFlightDetailsInfoController from "./useFlightDetailsInfo.controller.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { SkeletonListMultiLine } from "../../../Skeleton/SkeletonListMultiLine.js";
import { isOfMetaOrigin } from "../../../../../utils/marketing-url-params.js";
const FlightDetailsInfoDesktop = ({ flight, fetchStatus }) => {
    const { isLoading, items, initialItems } = useFlightDetailsInfoController({ flight, fetchStatus });
    const i18n = useI18n();
    const showBaggageInfoAsap = !isOfMetaOrigin() && flight.includedProducts?.segments.some((product) => product.length > 0);
    const loadingComponent = (React.createElement("div", { "aria-label": i18n.trans(t("a11y_flights_fd_additional_loading")) },
        React.createElement(SkeletonListMultiLine, { amount: 1 })));
    if (showBaggageInfoAsap) {
        return (React.createElement(React.Fragment, null,
            React.createElement(FlightDetailsInfoList, { attributes: { "data-testid": "flightdetails_ancillaries" }, variant: "two-columns", items: isLoading ? initialItems : items }),
            isLoading ? loadingComponent : undefined));
    }
    return (React.createElement(FlightDetailsInfoList, { attributes: { "data-testid": "flightdetails_ancillaries" }, variant: "two-columns", isLoading: isLoading, loadingComponent: loadingComponent, items: items }));
};
export default FlightDetailsInfoDesktop;
